import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MangeUnitsComponent } from './mange-units/mange-units.component';
import { UnitDetailsComponent } from './unit-details/unit-details.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { AddClientComponent } from './add-client/add-client.component';
import { AddunitComponent } from './addunit/addunit.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddquotaComponent } from './addquota/addquota.component';
import { MatMenuModule } from '@angular/material/menu';
import { UnitBlockComponent } from './unit-block/unit-block.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { AddNoteComponent } from './add-note/add-note.component';
import { MatTabsModule } from '@angular/material/tabs';
import { ImportClientComponent } from './import-client/import-client.component';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { InvtaionComponent } from './invtaion/invtaion.component';
import { AddCardComponent } from './add-card/add-card.component';
import { EditClientComponent } from './edit-client/edit-client.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgxPrintModule } from 'ngx-print';
import { ViewRfidComponent } from './view-rfid/view-rfid.component';
import { DeletRfidComponent } from './delet-rfid/delet-rfid.component';
import { EditRFIDComponent } from './edit-rfid/edit-rfid.component';
import { ViewClientComponent } from './view-client/view-client.component';
import { QrInvtationComponent } from './qr-invtation/qr-invtation.component';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { LogsClientComponent } from './logs-client/logs-client.component';
import { UnitInoviceComponent } from './unit-inovice/unit-inovice.component';

@NgModule({
  declarations: [
    MangeUnitsComponent,
    UnitDetailsComponent,
    AddClientComponent,
    AddunitComponent,
    AddquotaComponent,
    UnitBlockComponent,
    AddNoteComponent,
    ImportClientComponent,
    InvtaionComponent,
    AddCardComponent,
    EditClientComponent,
    ViewRfidComponent,
    DeletRfidComponent,
    EditRFIDComponent,
    ViewClientComponent,
    QrInvtationComponent,
    LogsClientComponent,
    UnitInoviceComponent
  ],
  imports: [
    CommonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatTooltipModule,
    CdkScrollable,
    MatTabsModule,
    MatInputModule,
    MatSelectModule,
    MatPaginatorModule,
    NgxPrintModule,
    NgxQRCodeModule
  ]
})
export class UnitsModule {}
